export default defineAppConfig({
    ui: {
      primary: 'orange',
      gray: 'cool'
    }
  })